import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  L3vpnSubscriptionDetailsGQL,
  L3vpnSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { L3vpnSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { L3vpnSubscriptionView } from "./l3vpn-subscription-view";

@Component({
  selector: "l3vpn-subscription",
  templateUrl: "l3vpn-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [L3vpnSubscriptionView, SubscriptionPageComponent],
})
export class L3vpnSubscription extends GenericSubscription<L3vpnSubscriptionDetailsQuery, L3vpnSubscriptionDetails> {
  protected query = inject(L3vpnSubscriptionDetailsGQL);

  protected onQuerySuccess(data: L3vpnSubscriptionDetailsQuery): L3vpnSubscriptionDetails {
    return data.l3vpnDetails;
  }
}
